export function mapNotificationFromApi(raw) {
    return {
        id: raw.id,
        slug: raw.id,
        title: raw.data?.title,
        message: raw.data?.message,
        type: raw.data?.additional_data?.type,
        uuids: raw.data?.additional_data?.uuids,
        image_url: raw.data?.additional_data?.image_url ?? null,
        read_at: raw.read_at,
        created_at: raw.created_at,
    }
}

export function mapNotificationFromReverb(raw) {
    return {
        id: raw.id,
        slug: raw.id,
        title: raw.title,
        message: raw.message,
        type: raw.additional_data?.type,
        uuids: raw.data?.additional_data?.uuids,
        image_url: raw.additional_data?.image_url ?? null,
        read_at: null,
        created_at: new Date().toISOString(),
    }
}
